var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintfunAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    viewBox: "0 0 294.5 90",
    className: "hidden md:flex",
    id: "svg10",
    height: 90,
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g839",
    transform: "translate(-17.184 -3.384)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.184 -98.866) scale(3.27222)",
    id: "g834",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 0C20.151 0 0 20.151 0 45s20.151 45 45 45 45-20.151 45-45S69.858 0 45 0Z",
    id: "path2",
    style: {
      fill: "#231f20",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      strokeWidth: 1.81548417
    },
    id: "path4",
    d: "m197.245 110.386-9.06 34.663c-1.042 4.135-5.177 7.503-9.315 7.503h-61.583c-4.136 0-6.734-3.368-5.692-7.503l9.316-34.663c1.042-4.138 5.18-7.504 9.315-7.504h61.327c4.152 0 6.734 3.35 5.692 7.504zM232.18-23.651l-26.648 105.82c-.768 3.366-3.622 5.692-6.99 5.692H136.96c-2.324 0-4.65-1.042-5.948-2.838-1.3-1.811-2.582-6.205 3.624-10.615l28.394-20.665c3.046-2.213 1.474-7.023-2.277-7.023h-36.972c-2.068 0-4.393-1.042-5.692-2.854-1.555-1.811-2.067-4.137-1.555-6.205l16.306-64.949c1.042-3.368 3.88-5.691 7.246-5.691h84.863c2.325 0 4.393 1.042 5.947 2.837a8.213 8.213 0 0 1 1.284 6.492z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintfunAlt);
export default __webpack_public_path__ + "static/media/mintfun_alt.a2d64f4930a1d137b3786fef1513112f.svg";
export { ForwardRef as ReactComponent };